export interface RegisteredPlayersByDate {
  cantidad: number;
  fecha: string | number;
  cantidad_anterior: number;
  fecha_anterior: string;
  fecha_inicio?: string;
  fecha_fin?: string;
  fecha_inicio_anterior?: string;
  fecha_fin_anterior?: string;
}

export interface PageBalanceDashboard {
  anio: number;
  mes: number;
  pagado_agente: string;
  pagado_referido1: string;
  pagado_referido2: string;
  pagado_referido3: string;
  pais: string;
  porcentaje: number;
  total_ganado: string;
  total_pagado: number;
}

export interface BankAccounts {
  ingreso: string;
  egreso: string;
  monto: string;
  cantidad: number;
  banco: string;
  titular: string;
  pais: string;
}

export interface ProfitPerPlayer {
  jugador: string;
  agente: string;
  cantidad_transacciones: number;
  ingreso: string;
  egreso: string;
  total: string;
}

export interface ProfitPerAgent extends Omit<ProfitPerPlayer, 'jugador'> { }

export interface ExpensesPerAccount {
  cuenta: string;
  cantidad_transacciones: number;
  monto: string;
}

export interface LatestExpenseMovements
  extends Omit<ExpensesPerAccount, 'cantidad_transacciones'> {
  fecha: string;
}

 export interface BankAccountFilters {
  page: number;
  limit: number;
  pais: string | null;
  banco: string | null;
  titular: string | null;
}

export interface BankAccountsResponse {
  bankAccounts: BankAccounts[];
  totalCount: number;
}

export interface Holder {
  usuario: string;
  idusuario: number;
}

export interface HoldersResponse {
  data: Holder[];
  message?: string;
}

export interface Bank {
  banco: string;
  idabpa_banco: number;
  id_pais: number;
  nameCountry: {
    pais: string;
  };
}

export interface SelectOption<T> {
  label: string;
  value: T;
  id?: number;
}
